import { render, staticRenderFns } from "./ApplicantMessageHistoryEntry.vue?vue&type=template&id=5d197d76"
import script from "./ApplicantMessageHistoryEntry.vue?vue&type=script&lang=js"
export * from "./ApplicantMessageHistoryEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports